import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import clsx from 'clsx';

export default function PageHeader({ title, description, breadcrumbs = [], actions = null }) {
  return (
    <header className="sticky top-0 z-10 mb-8 flex flex-col gap-4 bg-[rgba(var(--bg),_0.78)]/90 pb-6 pt-4 backdrop-blur-lg">
      <nav aria-label="Breadcrumb" className="text-sm text-[rgba(var(--fg),_0.72)]">
        <ol className="flex flex-wrap items-center gap-2">
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            const content = (
              <span
                className={clsx(
                  'inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium tracking-wide',
                  isLast
                    ? 'bg-[rgba(var(--brand),_0.12)] text-[rgb(var(--brand))]'
                    : 'bg-[rgba(var(--panel),_0.6)] text-[rgba(var(--fg),_0.72)]',
                )}
              >
                {crumb.icon ?? null}
                {crumb.label}
              </span>
            );

            return (
              <li key={`${crumb.href ?? crumb.label}-${index}`} className="flex items-center gap-2">
                {crumb.href && !isLast ? (
                  <Link to={crumb.href} className="focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent">
                    {content}
                  </Link>
                ) : (
                  content
                )}
                {!isLast ? <ChevronRight size={14} aria-hidden="true" className="text-[rgba(var(--fg),_0.45)]" /> : null}
              </li>
            );
          })}
        </ol>
      </nav>

      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="space-y-2">
          <h1 className="text-3xl font-semibold tracking-tight text-[rgb(var(--fg))]">{title}</h1>
          {description ? (
            <p className="max-w-2xl text-base text-[rgba(var(--fg),_0.72)]">{description}</p>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}
